import {
    GET_VEHICLE_REQUEST,
    GET_VEHICLE_SUCCESS,
    GET_VEHICLE_FAIL,
    GET_VEHICLES_REQUEST,
    GET_VEHICLES_SUCCESS,
    GET_VEHICLES_FAIL,
    GET_CUSTOMER_BY_VEHICLE_REQUEST,
    GET_CUSTOMER_BY_VEHICLE_SUCCESS,
    GET_CUSTOMER_BY_VEHICLE_FAIL,
    CREATE_VEHICLE_REQUEST,
    CREATE_VEHICLE_SUCCESS,
    CREATE_VEHICLE_FAIL
} from '../constants/vehicleConstants';

export const vehicleReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_VEHICLE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_VEHICLE_SUCCESS:
            return { ...state, loading: false, vehicle: action.payload, error: null };
        case GET_VEHICLE_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


export const vehiclesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_VEHICLES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_VEHICLES_SUCCESS:
            return { ...state, loading: false, vehicles: action.payload, error: null };
        case GET_VEHICLES_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


export const getCustomerByVehicleReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_CUSTOMER_BY_VEHICLE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_CUSTOMER_BY_VEHICLE_SUCCESS:
            return { ...state, loading: false, vehicleOwner: action.payload, error: null };
        case GET_CUSTOMER_BY_VEHICLE_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export const createVehicleReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_VEHICLE_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_VEHICLE_SUCCESS:
            return { ...state, loading: false, createVehicle: action.payload, error: null };
        case CREATE_VEHICLE_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};